<mat-dialog-content>
    <div class="pt-4 px-4 animated fadeIn" [ngSwitch]="data.name">
        <app-feature-payables *ngSwitchCase="'Payables Integration'" (getStartedEnrollment)="close()"></app-feature-payables>
        <app-feature-alliance-banking *ngSwitchCase="'Banking Integration'" (requestScheduleCall)="close()"></app-feature-alliance-banking>
    </div>
</mat-dialog-content>

<img class="mat-close" src="/assets/images/payhoa/other/icon_close.svg" mat-dialog-close>
